import { FaHeartbeat, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter, FaWhatsapp } from "react-icons/fa";
import { COMPANY, NAV_LINKS, SERVICES, PRODUCT_CATEGORIES } from "../data/content";

const Footer = () => {
    const goto = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

    return (
        <footer data-testid="site-footer" className="relative bg-slate-950 text-slate-300 pt-20 pb-8">
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-brand-700 via-sky-400 to-brand-700" />
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10">
                {/* Brand */}
                <div className="lg:col-span-4">
                    <div className="flex items-center gap-2.5">
                        <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-brand-700 to-brand-400 flex items-center justify-center shadow-lg">
                            <FaHeartbeat className="text-white text-xl" />
                        </div>
                        <div>
                            <div className="font-heading font-extrabold text-lg text-white">EZHIL BIOMEDICAL</div>
                            <div className="text-[11px] tracking-[0.18em] text-brand-300 uppercase">Sales &amp; Services</div>
                        </div>
                    </div>
                    <p className="mt-5 text-sm text-slate-400 leading-relaxed">
                        A premier medical equipment supplier and biomedical service provider serving hospitals, clinics, labs and diagnostic centres across Puducherry &amp; South India.
                    </p>
                    <div className="mt-6 flex gap-3">
                        {[FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter, FaWhatsapp].map((Icon, i) => (
                            <a key={i} href="#" data-testid={`footer-social-${i}`}
                               className="w-10 h-10 rounded-full bg-slate-800 hover:bg-brand-700 hover:text-white flex items-center justify-center transition-all hover:-translate-y-0.5">
                                <Icon className="text-sm" />
                            </a>
                        ))}
                    </div>
                </div>

                {/* Quick links */}
                <div className="lg:col-span-2">
                    <h4 className="font-heading font-semibold text-white">Quick Links</h4>
                    <ul className="mt-4 space-y-2 text-sm">
                        {NAV_LINKS.map((l) => (
                            <li key={l.id}>
                                <button onClick={() => goto(l.id)} data-testid={`footer-link-${l.id}`} className="hover:text-brand-300 transition">{l.label}</button>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Services */}
                <div className="lg:col-span-3">
                    <h4 className="font-heading font-semibold text-white">Services</h4>
                    <ul className="mt-4 space-y-2 text-sm">
                        {SERVICES.slice(0, 6).map((s) => (
                            <li key={s.title} className="text-slate-400 hover:text-brand-300 cursor-default transition">{s.title}</li>
                        ))}
                    </ul>
                </div>

                {/* Contact */}
                <div className="lg:col-span-3">
                    <h4 className="font-heading font-semibold text-white">Contact</h4>
                    <ul className="mt-4 space-y-3 text-sm">
                        <li className="flex gap-3"><FaMapMarkerAlt className="flex-shrink-0 mt-0.5 text-brand-400" /> <span className="text-slate-400">{COMPANY.address}</span></li>
                        <li><a href={`tel:${COMPANY.phoneDigits}`} className="flex gap-3 hover:text-brand-300"><FaPhoneAlt className="mt-0.5 text-brand-400" /> {COMPANY.phone}</a></li>
                        <li><a href={`mailto:${COMPANY.email}`} className="flex gap-3 hover:text-brand-300 break-all"><FaEnvelope className="mt-0.5 text-brand-400" /> {COMPANY.email}</a></li>
                    </ul>
                </div>
            </div>

            {/* Categories strip */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 pt-8 border-t border-slate-800">
                <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-3">Popular Categories</div>
                <div className="flex flex-wrap gap-2 text-xs">
                    {PRODUCT_CATEGORIES.slice(0, 14).map((c) => (
                        <span key={c.name} className="px-3 py-1.5 rounded-full bg-slate-900 border border-slate-800 text-slate-400 hover:text-brand-300 hover:border-brand-700 cursor-default transition">{c.name}</span>
                    ))}
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10 pt-6 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
                <div>© {new Date().getFullYear()} Ezhil Biomedical Sales and Services. All rights reserved.</div>
                <div>Crafted with care for healthcare professionals.</div>
            </div>
        </footer>
    );
};

export default Footer;
